import BaseTextField from "../../../../components/ui/BaseTextField";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkOrderForm,
  updateWorkOrderFormValidation,
} from "../../../../store/workOrder/workOrderSlice";

const EngineerHalfDayPay = () => {
  const dispatch = useDispatch();
  const payment = useSelector((state) => state.workOrder.payment.pay);
  const workOrderFormValidation = useSelector(
    (state) => state.workOrder.workOrderFormValidation
  );
  const handleChange = (event) => {
    const { name, value } = event.target;
    const parsedValue = parseFloat(value);
    dispatch(
      updateWorkOrderForm({
        step: "payment",
        data: {
          pay: {
            [name]: value,
          },
        },
      })
    );

     if (name === "engineerHalfDayRate" && parsedValue > 0) {
      dispatch(
        updateWorkOrderFormValidation({
          fieldName: "engineerHalfDayRate",
          data: false,
        })
      );
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-4 mt-3">
      <div className="mr-10">
        <BaseTextField
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.engineerHalfDayRate}
          errorMsg={workOrderFormValidation.engineerHalfDayRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="engineerHalfDayRate"
          name="engineerHalfDayRate"
          label="Half Day Rate"
          requirement="required"
          labelShrink={false}
          value={payment.engineerHalfDayRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
      </div>

      <div>
        <BaseTextField
          onInput={(e) => (e.target.value = e.target.value.replace(/-/g, ""))}
          error={workOrderFormValidation.engineerHourlyRate}
          errorMsg={workOrderFormValidation.engineerHourlyRateErrorMsg}
          fullWidth
          fullHeight={false}
          id="engineerHourlyRate"
          name="engineerHourlyRate"
          label="Additional Hour Rate"
          requirement="required"
          labelShrink={false}
          value={payment.engineerHourlyRate}
          onChange={handleChange}
          isDefaultField={false}
          type="float"
        />
        <p className="mt-2 text-sm text-right">
          Additional hourly rate will be applicable after 4 hours of work
        </p>
      </div>
    </div>
  );
};

export default EngineerHalfDayPay;
